"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorSelectorRoot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _colorPickerTheme = require("../../colorPickerTheme");
const ColorSelectorRoot = (0, _styled.default)("div")`
    position: relative;
    padding: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _colorPickerTheme.colorPickerTheme.colorSelector.padding(themeMode);
}};
    box-sizing: border-box;
    width: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _colorPickerTheme.colorPickerTheme.colorSelector.width(themeMode);
}};
    background: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _colorPickerTheme.colorPickerTheme.colorSelector.backgroundColor(themeMode);
}};
    box-shadow: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _colorPickerTheme.colorPickerTheme.colorSelector.boxShadow(themeMode);
}};
    border-radius: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _colorPickerTheme.colorPickerTheme.colorSelector.borderRadius(themeMode);
}};
`;
exports.ColorSelectorRoot = ColorSelectorRoot;
//# sourceMappingURL=ColorSelectorRoot.js.map